import React from "react";
import { arrayHasAtLeastTwoItems } from "common/utils/arrays";
import { Button } from "../../../../Common/Buttons/Button";
import { Icon } from "../../../../Common/Icons/LucideIcons";
import { useValidationErrorModal } from "../ValidationErrorModal";
import { SubmissionsBuilderButtonsWrapper } from "./__styles__/SubmissionsBuilder";

export const MenuRightButtons = ({
  isRightSideBarOpen,
  openRightSideBar,
  closeRightSideBar,
  versions,
  onSave,
  disabled,
  formIsDirty,
  validationErrors,
  children,
}: {
  isRightSideBarOpen: boolean;
  openRightSideBar: (selectedVersionId: string) => void;
  closeRightSideBar: () => void;
  versions: { id: string }[];
  onSave: () => void;
  disabled: boolean;
  formIsDirty: boolean;
  validationErrors?: { path: string; message: string }[];
  children?: React.ReactNode;
}) => {
  const canOpenRightSideBar = arrayHasAtLeastTwoItems(versions) && !formIsDirty;

  const [showErrorModal] = useValidationErrorModal(validationErrors);

  return (
    <SubmissionsBuilderButtonsWrapper>
      {canOpenRightSideBar &&
        (isRightSideBarOpen ?
          <Button
            variant="outline"
            size="small"
            onPress={closeRightSideBar}
            isDisabled={formIsDirty}
            title="Return to current version"
          />
        : <Icon
            iconName="history"
            color="contentSecondary"
            size={16}
            cursor="pointer"
            testId="version-history"
            onClick={() => openRightSideBar(versions[0].id)}
          />)}
      {disabled && validationErrors && validationErrors.length > 0 && (
        <Icon
          iconName="circle-help"
          color="contentSecondary"
          size={20}
          cursor="pointer"
          testId="validation-help"
          onClick={showErrorModal}
        />
      )}
      <Button
        variant="primary"
        size="small"
        onPress={onSave}
        isDisabled={disabled}
        title="Save"
      />
      {children}
    </SubmissionsBuilderButtonsWrapper>
  );
};
